import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import(/* webpackChunkName: "Home" */ './views/Home.vue'),
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "Login" */ './views/Login.vue')
        },
        {
            path: '/project/:projectId',
            name: 'project',
            component: () => import(/* webpackChunkName: "Login" */ './views/Detail.vue')
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import(/* webpackChunkName: "Settings" */ './views/Settings.vue')
        },
        {
            path: '/users',
            name: 'users',
            component: () => import(/* webpackChunkName: "Users" */ './views/Users.vue')
        },
        {
            path: '/account/:userId',
            name: 'admin account',
            component: () => import(/* webpackChunkName: "Account" */ './views/Account.vue')
        },
        {
            path: '/account',
            name: 'own account',
            component: () => import(/* webpackChunkName: "Account" */ './views/Account.vue')
        }
    ]
})
